/* projects/common-module/src/lib/app-components/auth-user-chip/auth-user-chip.component.scss */
.theme-DEFAULT {
  --color-primary: #386dac;
  --color-accent: #FF4081;
  --color-minor: #c5cae9;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-BLUE {
  --color-primary: #002395;
  --color-accent: #F8D030;
  --color-minor: #CFD8DC;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-RED {
  --color-primary: #b63134;
  --color-accent: #FF9800;
  --color-minor: #e5c0c1;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-RED2 {
  --color-primary: #666465;
  --color-accent: #E30611;
  --color-minor: #e5c0c1;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-PURPLE {
  --color-primary: #7B1FA2;
  --color-accent: #E040FB;
  --color-minor: #E1BEE7;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-GREEN {
  --color-primary: #00796B;
  --color-accent: #03A9F4;
  --color-minor: #B2DFDB;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-GRAY {
  --color-primary: #455A64;
  --color-accent: #ff5252;
  --color-minor: #CFD8DC;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-BLACK {
  --color-primary: #000000;
  --color-accent: #da291c;
  --color-minor: #dda4a0;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.user-chip {
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: 220px;
  height: 40px;
  padding: 0 4px 0 6px;
  border: 0;
  border-radius: 20px;
  background: transparent;
  color: var(--color-white);
  font-family:
    "Helvetica Neue",
    Helvetica,
    sans-serif;
  font-size: 1.3rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 150ms;
}
.user-chip:hover {
  background: rgba(255, 255, 255, 0.08);
}
.user-chip:active {
  background: rgba(255, 255, 255, 0.14);
}
.user-chip:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.85);
  outline-offset: -2px;
}
.user-chip__arrow {
  flex: none;
  font-size: 1.8rem;
  width: 1.8rem;
  height: 1.8rem;
  line-height: 1.8rem;
}
/*# sourceMappingURL=auth-user-chip.component.css.map */
